import { Skeleton } from "@mui/material";
import classNames from "classnames";
import { SegmentedPillsSkeleton } from "../primitives";
import styles from "./style.module.scss";

interface RangeFilterBarSkeletonProps {
  presetCount?: number;
  withCustomize?: boolean;
  className?: string;
}

function RangeFilterBarSkeleton({
  presetCount = 4,
  withCustomize = true,
  className,
}: RangeFilterBarSkeletonProps) {
  return (
    <div className={classNames(styles.bar, className)}>
      <SegmentedPillsSkeleton count={presetCount} width={92} />
      {withCustomize && (
        <Skeleton
          variant="rounded"
          width={162}
          height={40}
          sx={{ borderRadius: "999px" }}
        />
      )}
    </div>
  );
}

export default RangeFilterBarSkeleton;
